import React, { Component } from 'react'
import PropTypes            from 'prop-types';
import SegmentMedia         from './SegmentMedia';
import CollapsibleContent   from './CollapsibleContent';

class PlaceBody extends Component
{
    renderCaption = (caption, style = {}) =>
    {
        if ((caption + '').length > 0)
        {
            return <p style={ style } className="image-caption">{ caption }</p>
        }
        return null;
    };

    //---------------------------------------------------------------------------------------------------------------

    renderBody = () =>
    {
        return this.props.body.map((segment, index) =>
        {
            if ('html' === segment.type)
            {
                return <div key={ 'body-segment' + index } className="place-info-body" dangerouslySetInnerHTML={{__html: segment.data }} />
            }
            else if (['audio', 'video', 'youtube'].includes(segment.type))
            {
                return <SegmentMedia
                    caption={ this.renderCaption(segment.caption) }
                    url={ segment.data }
                    type={ segment.type }
                    key={ 'body-segment' + index }
                />;
            }
            else if ('image' === segment.type)
            {
                return (
                    <div key={ 'body-segment' + index } className="place-info-body">
                        <img className="body-image" src={ segment.data } alt="Places and Trails"  />
                        { this.renderCaption(segment.caption) }
                    </div>
                );
            }
            else if ('collapse')
            {
                return <CollapsibleContent
                    openText={ segment.revealHeader }
                    closeText={ segment.hideHeader }
                    content={ segment.data }
                    key={ 'body-segment' + index }
                />;
            }

            return null;
        });
    };

    //---------------------------------------------------------------------------------------------------------------

    render = () => 
    {
        return (
            <div>
                { this.renderBody() }
            </div>
        )
    }
}

PlaceBody.propTypes = {
    body: PropTypes.array.isRequired
};

export default PlaceBody;


// WEBPACK FOOTER //
// ./src/components/Place/PlaceBody.js